import axios from 'axios';

let prefix = "/gacha-item"

const GachaItemApi = {
	listGachaItem(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	bulkCreateGachaItem(payload) {
		return axios.post(prefix + "/bulk-create", payload)
	},
	bulkUpdateGachaItem(payload) {
		return axios.post(prefix + "/bulk-update", payload)
	},
	archiveGachaItem(payload) {
		return axios.delete(prefix + "/archive", { params: payload })
	},
	createGachaItem(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateGachaItem(payload) {
		return axios.post(prefix + "/update", payload)
	},
}

export default GachaItemApi;